// created by Mateusz Klimaszewski for COMBO demo

import React from 'react';
import { ExternalLink } from '@allenai/varnish/components';
import { withRouter } from 'react-router-dom';

import { API_ROOT } from '../../api-config';
import Model from '../Model'
import { Tree } from 'hierplane';

const title = "Wstępne przetwarzanie języka naturalnego";

const description = (
  <span>
      <a href="https://gitlab.clarin-pl.eu/syntactic-tools/combo">COMBO</a> to nowej generacji system
      do tagowania, analizy morfologicznej, lematyzacji i parsowania zależnościowego, czyli podstawowych
      zadań wstępnego przetwarzania języka. Demo wykorzystuje modele wytrenowane na
      <a href="https://github.com/UniversalDependencies/UD_Polish-PDB"> PDB-UD </a>
      (<a href="https://aclweb.org/anthology/W18-6020">Wróblewska, 2018</a>).
      System COMBO powstał w <a href="http://ipipan.waw.pl">IPI PAN</a>, a obecnie jest rozwijany w
      projekcie <a href="https://clarin.biz">CLARIN-PL-Biz</a>.
  </span>
);

const descriptionEllipsed = null;

const fields = [
    {name: "sentence", label: "Proszę wpisać jedno zdanie", type: "TEXT_INPUT", placeholder: `Np. "COVID-19 to ostra choroba zakaźna układu oddechowego wywołana zakażeniem wirusem SARS-CoV-2."`},
];

const HierplaneVisualization = ({tree}) => {
    if (tree) {
        return (
            <div className="hierplane__visualization">
                <Tree tree={tree} theme="light" />
            </div>
        )
    } else {
        return null;
    }
};

const Output = ({ responseData }) => (
    <HierplaneVisualization tree={responseData.hierplane_tree} />
);

const examples = [
    "COVID-19 to ostra choroba zakaźna układu oddechowego wywołana zakażeniem wirusem SARS-CoV-2.",
    "To są nasze najlepsze dni.",
    "Ciemno już, zgasły wszystkie światła.",
  ].map(sentence => ({sentence}));

const apiUrl = () => `${API_ROOT}/predict/combo-pl`;

const modelProps = {apiUrl, title, description, descriptionEllipsed, fields, examples, Output};

export default withRouter(props => <Model {...props} {...modelProps}/>)
